import { TrophyOutlineIcon } from './TrophyOutlineIcon';

/**
 * author: Simran
 * id D7B01958-C212-49B9-B58B-146B4017348C
 * name trophy-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trophy-outline.svg
 * tags
 * - Sport 
 */
export const AchievementOutlineIcon = TrophyOutlineIcon;
export default AchievementOutlineIcon